"use client";

import { useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { makeRequest } from "../../../_config/api";
import { ToastContainer } from "react-toastify";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";

export default function ForgotForm({ switchTab }) {
  const [step, setStep] = useState("forgot");
  const [userId, setUserId] = useState(null);

  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  // SEND OTP
  const handleForgot = async () => {
    if (!email.trim()) return showErrorToast("Enter email");

    setLoading(true);
    try {
      const res = await makeRequest("POST", "/user/forgot-password", { email });

      if (res?.error) return showErrorToast(res.message || "Failed");

      setUserId(res?.data?.userId);
      setStep("otp");
      showSuccessToast("OTP sent successfully");
    } catch (err) {
      showErrorToast(err?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // VERIFY
  const handleVerify = async () => {
    if (!otp) return showErrorToast("Enter OTP");
    if (password.length < 6)
      return showErrorToast("Password must be minimum 6 characters");

    setLoading(true);
    try {
      const res = await makeRequest("POST", "/user/forgot-verify", {
        userId,
        otp,
        newPassword: password,
      });

      if (res?.error) return showErrorToast(res.message || "Failed");

      showSuccessToast("Password reset successful 🎉");

      setTimeout(() => switchTab("login"), 1500);
    } catch (err) {
      showErrorToast(err?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />

      {loading && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 flex flex-col items-center shadow-lg">
            <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-[#132b45]"></div>
            <p className="mt-4 text-[#132b45] font-medium">Loading...</p>
          </div>
        </div>
      )}

      {step === "forgot" ? (
        <div className="space-y-4">
          <h2 className="text-xl font-bold text-center text-[#162e40]">
            Forgot Password
          </h2>

          <input
            type="email"
            placeholder="Enter registered email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-3 border rounded-md"
          />

          <button
            type="button"
            onClick={handleForgot}
            className="w-full py-3 bg-[#162e40] text-white rounded-md"
          >
            Send OTP
          </button>
        </div>
      ) : (
        <div className="space-y-4">
          <h2 className="text-xl font-bold text-center text-[#162e40]">
            Reset Password
          </h2>

          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
            maxLength={6}
            className="w-full p-3 border rounded-md"
          />

          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="New Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-3 border rounded-md"
            />
            <span
              className="absolute right-4 top-4 cursor-pointer"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FiEyeOff /> : <FiEye />}
            </span>
          </div>

          <button
            type="button"
            onClick={handleVerify}
            className="w-full py-3 bg-[#162e40] text-white rounded-md"
          >
            Reset Password
          </button>
        </div>
      )}
    </>
  );
}
